import React, { useState } from "react";
import { connect } from "react-redux";
import { broadcastAnd, addChat, setRoom, changeUser } from "../redux/actions";
import { selectCanSeeControls } from "../redux/selectors";
import { faLock, faUnlock } from "@fortawesome/free-solid-svg-icons";

import IconButton from "./IconButton";
import PasswordModal from "./PasswordModal";
import FixedClock from "../lib/FixedClock";

const UnconnectedLockControls = (props) => {

    const [showModal, setShowModal] = useState("");

    const getUserInfo = () => ({
        nick_name: props.nick_name,
        room_key: props.room_key
    });

    const getFullRoomDetails = () => ({
        is_playing: props.is_playing,
        video_url: props.video_url,
        subtitle_url: props.subtitle_url,
        video_position: props.ideal_position,
        video_position_timestamp: FixedClock.utc(),
        video_length: props.video_length,
        password: props.password
    });

    const sendChat = (msg) => {
        props.broadcastAnd({
            ...getUserInfo(),
            namespace: "chat",
            action: addChat(props.nick_name, msg)
        });
    };

    const changeRoom = (changes,msg) => {
        const newState = { ...getFullRoomDetails(),...changes };
        props.broadcastAnd({
            ...getUserInfo(),
            namespace: "control",
            action: setRoom(newState)
        });
        sendChat(msg);
    };

    const handleClearLock = () => { changeRoom({ password: "" }, "[Removed lock on controls]"); };

    const handleLockControls = (password) => {
        changeRoom({ password }, "[Locked controls]");
        props.changeUser("room_password", password);
        hideModal();
    };

    const handleUnlockControls = (password) => {
        props.changeUser("room_password", password);
        hideModal();
    };

    const hideModal = () => { setShowModal(""); };

    const renderBtn = () => {
        if (props.password) {
            if (props.canSeeControls) {
                return (<IconButton title="Remove lock" key="clearlock" icon={faLock} highlighted="true" onClick={handleClearLock}>Remove lock</IconButton>);
            } else {
                return (<IconButton title="Enter password to access controls" key="unlock" icon={faUnlock} onClick={setShowModal.bind(this,"unlock")}>Unlock</IconButton>);
            }
        } else {
            return (<IconButton title="Set a password to restrict controls" key="lock" icon={faLock} onClick={setShowModal.bind(this,"lock")}>Lock</IconButton>);
        }
    };

    const renderModal = () => {
        switch(showModal) {
            case "lock":
                return <PasswordModal title="Lock Controls" onClose={hideModal} onClick={handleLockControls} />;
            case "unlock":
                return <PasswordModal title="Unlock Controls" onClose={hideModal} onClick={handleUnlockControls} />;
            default:
                return null;
        }
    };

    return (<>{renderBtn()}{renderModal()}</>);
    
};

const mapStateToProps = state => ({ 
    canSeeControls: selectCanSeeControls(state),
    password: state.room.password, 
    nick_name: state.user.nick_name, 
    room_key: state.user.room_key, 
    view_mode: state.user.view_mode,
    video_length: state.room.video_length,
    ideal_position: state.user.ideal_position,
    video_position: state.room.video_position,
    room_password: state.user.room_password,
    is_playing: state.room.is_playing,
    video_url: state.room.video_url,
    subtitle_url: state.room.subtitle_url
});

export const LockControls = connect(mapStateToProps, { broadcastAnd, changeUser })(UnconnectedLockControls);